<template>
    <div v-if="visible" class="cookie-banner">
        <p>
            This website uses cookies to enhance user experience, to analyze performance and traffic on our website. We
            also share information about your use of our site with our social media, advertising and analytics partners.
            By clicking <strong>ACCEPT ALL</strong> or continuing to browse this Platform (more than one click), you are
            agreeing to our use of cookies and sharing of information about your use of our site with our social media,
            advertising and analytics partners. Further information is available in our
            <a href="/privacy" target="_blank">Cookie Policy</a>,
            <a href="/terms" target="_blank">Do Not Sell or Share My Personal Information</a>.
        </p>
        <button @click="acceptCookies" class="btn-accept">ACCEPT ALL</button>
    </div>
</template>

<script>
export default {
    name: 'CookieConsent',
    data() {
        return {
            visible: false,
        }
    },
    mounted() {
        // verifică dacă utilizatorul a acceptat deja cookie-urile
        if (!localStorage.getItem('cookiesAccepted')) {
            this.visible = true
        }
    },
    methods: {
        acceptCookies() {
            localStorage.setItem('cookiesAccepted', true)
            this.visible = false
        },
    },
}
</script>

<style scoped>
.cookie-banner {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid #ddd;
    padding: 25px;
    font-size: 14px;
    color: #333;
    z-index: 9999;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.cookie-banner p {
    margin: 0;
    flex: 1;
    padding-right: 20px;
    font-family: 'Inter';
}

.cookie-banner a {
    color: #0056b3;
    text-decoration: underline;
}

.btn-accept {
    background: #800020;
    border: none;
    padding: 10px 20px;
    font-weight: bold;
    color: white;
    cursor: pointer;
    border-radius: 5px;
}
</style>
